import { SystemConfig } from './../models/SystemConfig';
import { LIFE_CORP_TEL_NO } from './../app.constant';
import { SystemDataService } from './../service/data/system-data.service';
import { Account } from './../models/account';
import { AccountDataService } from './../service/data/account-data.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {


  showEnterUsername = false;
  showEnterPhoneNumber = false;

  
  form: FormGroup = this.fb.group({
    // {5}
    userName: ["", [Validators.required]],
    phoneNo: ["", [Validators.required]]
  });

  private formSubmitAttempt: boolean;

  otherErrorMesssage: string = "";

  noEmailIsRegistered: boolean = false;

  passwordResetIsSuccessful: boolean = false;

  constructor(private router: Router, private accountDataService: AccountDataService, private fb: FormBuilder, private systemDataService: SystemDataService) { }

  lifeCorpHotline = "";

  ngOnInit() {


    // this.form = this.fb.group({
    //   // {5}
    //   userName: ["", [Validators.required]],
    //   phoneNo: ["", [Validators.required]]
    // });

    

    //this.lifeCorpHotline

    this.systemDataService.getSystemConfig(LIFE_CORP_TEL_NO).subscribe(

      response => {

        var firstKey = Object.keys(response)[0];

        let systemConfig: SystemConfig;

        if (firstKey.toUpperCase() == "OK") {

          systemConfig = response[firstKey];

          this.lifeCorpHotline = systemConfig.value;
        }

      },
      error => {

      }

    );

  }

  resetAlertMessage() {

    this.otherErrorMesssage = "";

    this.noEmailIsRegistered = false;

    this.passwordResetIsSuccessful = false;
  }

  resetPasswordClicked() {

    this.resetAlertMessage();

    this.form.valid

    if(this.form.get('userName').valid && this.form.get('phoneNo').valid){
      this.accountDataService.resetPassword(this.form.value.userName, this.form.value.phoneNo).subscribe(
        response => {
  
          var resetPasswordFirstKey = Object.keys(response)[0];
  
          if (resetPasswordFirstKey.toUpperCase() == "OK") {
            this.passwordResetIsSuccessful = true;
          }
          else
            if (resetPasswordFirstKey.toUpperCase() == "ERROR") {
  
              this.otherErrorMesssage = response[resetPasswordFirstKey];

              if(this.otherErrorMesssage ==='Cannot reset password. Missing email.'){
                this.noEmailIsRegistered = true;
                this.otherErrorMesssage = ''
              }
            }
  
        },
        error => {
  
        }
      );
    }

    // this.accountDataService.getAccount(this.form.value.userName).subscribe(

    //   response => {

    //     var getAccountResponsefirstKey = Object.keys(response)[0];


    //     let account: Account;

    //     // check if account exists
    //     if (getAccountResponsefirstKey.toUpperCase() == "OK") {

    //       account = response[getAccountResponsefirstKey];

    //       // check if the account has email
    //       if (account.emailAddress == null || account.emailAddress == "") {
    //         this.noEmailIsRegistered = true;




    //       }
    //       else {
    //         // if account is found and email is registered
    //         this.accountDataService.resetPassword(this.form.value.userName).subscribe(
    //           response => {

    //             var resetPasswordFirstKey = Object.keys(response)[0];

    //             if (resetPasswordFirstKey.toUpperCase() == "OK") {
    //               this.passwordResetIsSuccessful = true;
    //             }
    //             else
    //               if (resetPasswordFirstKey.toUpperCase() == "ERROR") {

    //                 // password reset failed due to other reasons
    //                 this.otherErrorMesssage = response[resetPasswordFirstKey];

    //               }

    //           },
    //           error => {

    //           }
    //         );
    //       }

    //     }
    //     else
    //       if (getAccountResponsefirstKey.toUpperCase() == "ERROR") {
    //         this.otherErrorMesssage = response[getAccountResponsefirstKey];
    //       }

    //   },
    //   error => {

    //   }

    // );



  }

  goBackLoginPage() {
    this.router.navigate(["login"]);
  }


  isUserNameFieldInvalid(field: string) {
    // {6}
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }

  isPhoneNoFieldInvalid(field: string) {
    // {6}
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }
}
